import { jsx as _jsx } from "react/jsx-runtime";
import { StyledDateCalendar } from "../../Shared/components/DateTimePickers/StyledDateCalendar";
import moment from "moment";
import { CustomDateCalendarHeader } from "../../Shared/components/DateTimePickers/CustomDateCalendarHeader";
import { SimpleCustomPickersDay } from "../../Shared/components/DateTimePickers/CustomPickersDay";
export default function DateCalendarExample() {
    return (_jsx(StyledDateCalendar, { minDate: moment(), maxDate: moment().add(1, "year"), disablePast: true, disableHighlightToday: true, slots: { calendarHeader: CustomDateCalendarHeader, day: SimpleCustomPickersDay }, slotProps: {
            calendarHeader: { hideArrows: false },
        }, views: ["day"] }));
}
